import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersPromocodesParams, GetVouchersPromocodesResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersPromocodes = createAsyncThunk<
  GetVouchersPromocodesResponse,
  GetVouchersPromocodesParams
>(
  `vouchers/getVouchersPromocodes`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersPromocodes({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers promocodes",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers promocodes", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);